import { TRANSPORTATION_ORIGIN } from '~config/publicEnv';
import { TokenRefreshResponse, TokenWebViewResponse, TokenWebViewRequest } from '~models/TokenDto';
import { HttpClient } from '~utils/https/HttpClientFetch';

/**
 * @title Token API
 * @baseUrl https://www.myrealtrip.com/transportation/api/token
 *
 */
class TokenApi<SecurityDataType> extends HttpClient<SecurityDataType> {
  v1 = {
    /**
     * @description 웹 환경의 토큰 유효 여부를 검증합니다. 유효한 경우 토큰은 갱신 처리 됩니다.
     *
     * @tags front-token-controller
     * @name refresh
     * @summary 웹 토큰 검증/갱신 API
     * @request POST:/token/refresh
     */
    refresh: () =>
      this.request<TokenRefreshResponse>({
        path: `/refresh`,
        method: 'POST',
        format: 'json',
      }),
    /**
     * @description 웹뷰 환경의 토큰 유효 여부를 검증합니다. 유효한 경우 토큰은 갱신 처리 됩니다.
     *
     * @tags front-token-controller
     * @name webview
     * @summary 웹뷰 토큰 검증/갱신 API
     * @request POST:/token/webview
     */
    webview: (requestBody?: TokenWebViewRequest) =>
      this.request<TokenWebViewResponse>({
        path: `/webview`,
        method: 'POST',
        format: 'json',
        body: requestBody,
      }),
  };
}

const tokenApi = new TokenApi({
  baseURL: `${TRANSPORTATION_ORIGIN}/api/token`,
  secureWorker(securityData) {
    return {
      headers: {
        Authorization: `Bearer ${securityData}`,
      },
    };
  },
  secure: false,
});

export { tokenApi };
